<template>
  <div class="app">
    <!-- 👇 首页专属SEO内容（视觉上隐藏，搜索引擎可读） -->
    <div style="position:absolute;left:-9999px;top:-9999px;width:1px;height:1px;overflow:hidden;" aria-hidden="true">
      <h1>灵动帧 - AI视频翻译/字幕生成/语音克隆一站式平台 | 深圳灵动帧智能科技有限公司</h1>
      <p>灵动帧SaaS平台提供：视频翻译、字幕自动生成、说话人标签识别、音频翻译、视频对口型、语音克隆、B站视频下载、YouTube视频下载、音频降噪、音频转字幕等AI服务。支持中英日韩德法等20+语言，一键处理，高效精准。</p>
    </div>

    <!-- 模块1：视频翻译 -->
    <section id="video-translation" class="section-white">
      <div class="container">
        <div class="text-center">
          <h2 class="section-title" style="cursor:pointer;">
            <router-link to="/video" style="color:inherit;text-decoration:none;">
              视频翻译
            </router-link>
          </h2>
          <p class="section-description">
            视频翻译，支持字幕翻译、语音克隆和翻译、视频人物对口型，实现视频内容跨越语言障碍
          </p>
        </div>
        <div class="video-comparison">
          <div class="video-player">
            <div class="video-header">
              <h3>原始视频</h3>
            </div>
            <div class="video-content">
              <!-- 修复：添加内联播放属性，防止移动端浏览器强制全屏或浮层遮挡 -->
              <video
                controls
                preload="metadata"
                playsinline
                webkit-playsinline
                disablepictureinpicture
                x5-video-player-type="h5-page"
                x5-video-player-fullscreen="false"
                :src="TranSorURL"
              >
                您的浏览器不支持视频播放
              </video>
            </div>
          </div>
          <div class="video-player">
            <div class="video-header">
              <h3>翻译后视频</h3>
            </div>
            <div class="video-content">
              <!-- 修复：添加内联播放属性，防止移动端浏览器强制全屏或浮层遮挡 -->
              <video
                controls
                preload="metadata"
                playsinline
                webkit-playsinline
                disablepictureinpicture
                x5-video-player-type="h5-page"
                x5-video-player-fullscreen="false"
                :src="TranResURL"
              >
                您的浏览器不支持视频播放
              </video>
            </div>
          </div>
        </div>
        <div class="features-grid">
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-language"></i>
            </div>
            <h3>字幕翻译</h3>
            <p>将视频字幕翻译成目标语言</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-microphone-alt"></i>
            </div>
            <h3>语音克隆和翻译</h3>
            <p>保持原视频音色情感和语调，克隆翻译成目标语言</p>
          </div>
          <div class="feature-card">
            <div class="feature-icon">
              <i class="fas fa-user-edit"></i>
            </div>
            <h3>视频人物对口型</h3>
            <p>同步口型与翻译语音</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 模块2：音频处理 -->
    <section id="audio-processing" class="section-gray">
      <div class="container">
        <div class="text-center">
          <h2 class="section-title" style="cursor:pointer;">
            <router-link to="/adjust" style="color:inherit;text-decoration:none;" >
              音频处理
            </router-link>
          </h2>
          <p class="section-description">
            专业的音频处理工具，包括音频降噪和音频生成字幕，提升您的音频质量
          </p>
        </div>
        <div class="audio-processing-grid">
          <!-- 音频降噪 -->
          <div class="audio-processing-card">
            <div class="processing-header">
              <h3>音频降噪</h3>
            </div>
            <div class="audio-content">
              <div class="audio-section">
                <h4>原始音频</h4>
                <div class="audio-player">
                  <audio controls preload="metadata" :src="voiceDenoiseSorURL">
                    您的浏览器不支持音频播放
                  </audio>
                </div>
              </div>
              <div class="audio-section">
                <h4>降噪后音频</h4>
                <div class="audio-player">
                  <audio controls preload="metadata" :src="voiceDenoiseResURL">
                    您的浏览器不支持音频播放
                  </audio>
                </div>
              </div>
              <p>AI 智能降噪技术，去除背景噪音、风声、电流声等干扰，提升音频清晰度</p>
            </div>
          </div>
          <!-- 音频生成字幕 -->
          <div class="audio-processing-card">
            <div class="processing-header">
              <h3>音频生成字幕</h3>
            </div>
            <div class="audio-content">
              <div class="audio-section">
                <h4>音频文件</h4>
                <div class="audio-player">
                  <audio controls preload="metadata" :src="voiceSrtSorURL">
                    您的浏览器不支持音频播放
                  </audio>
                </div>
              </div>
              <div class="subtitle-section">
                <h4>生成字幕</h4>
                <div class="subtitle-content">
                  <div class="subtitle-item">
                    <span class="subtitle-time">00:00:00,645 --> 00:00:06,732</span>
                    <p>哈喽宝宝们，我是芫茜。今天和宝宝们分享雅诗兰黛小棕瓶第七代精华的正确法啦。</p>
                  </div>
                  <div class="subtitle-item">
                    <span class="subtitle-time">00:00:06,732 --> 00:00:12,118</span>
                    <p>油皮和混油皮的宝宝，建议你晚上使用；干皮的宝宝，你白天晚上都可以用起来啦。</p>
                  </div>
                  <div class="subtitle-item">
                    <span class="subtitle-time">00:00:12,118 --> 00:00:18,645</span>
                    <p>正确的用法呢，看见没有？每次使用，它大概是半管啊，大概是一滴、两滴、三滴、四滴、五滴就可以了。</p>
                  </div>
                  <div class="subtitle-item">
                    <span class="subtitle-time">00:00:18,645 --> 00:00:23,330</span>
                    <p>五滴在我们的掌心，用你的体温乳化开啊，按压你全脸。</p>
                  </div>
                  <div class="subtitle-item">
                    <span class="subtitle-time">00:00:23,330 --> 00:00:31,400</span>
                    <p>告诉宝宝们一个手法：双心按摩法，在你的脸部画心心，让所有的营养成分都按压在肌肤当中。</p>
                  </div>
                  <div class="subtitle-item">
                    <span class="subtitle-time">00:00:31,400 --> 00:00:36,006</span>
                    <p>还要注意我们淋巴的排毒，每天给自己排排毒，让你的体格变得更好。</p>
                  </div>
                  <div class="subtitle-item">
                    <span class="subtitle-time">00:00:36,206 --> 00:00:38,500</span>
                    <p>坚持使用，让你水光肌肤。</p>
                  </div>
                </div>
              </div>
              <p>AI 语音识别技术，自动将音频内容转为文字，支持多语言识别和时间轴标记</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 模块3：视频下载 -->
    <section id="video-download" class="section-white">
      <div class="container">
        <div class="text-center">
          <h2 class="section-title" style="cursor:pointer;">
            <router-link to="/voiceClone" style="color:inherit;text-decoration:none;">
              视频下载
            </router-link>
          </h2>
          <p class="section-description">
            一键下载各大平台视频，支持多种分辨率选择和格式转换
          </p>
        </div>
        <div class="download-card">
          <div class="download-interface">
            <img :src="videoDownURL" alt="视频下载界面"/>
          </div>
          <div class="supported-platforms">
            <h3>支持的平台</h3>
            <div class="platform-grid platform-center">
              <div class="platform-item">
                <div class="platform-icon-wrapper">
                  <i class="fab fa-youtube"></i>
                </div>
                <span class="platform-label">YouTube</span>
              </div>
              <div class="platform-item">
                <div class="platform-icon-wrapper">
                  <svg viewBox="0 0 1024 1024" width="1em" height="1em">
                    <path d="M256 192l-64-64a32 32 0 1 1 45-45l64 64a32 32 0 1 1-45 45zm576-64a32 32 0 0 0-45 0l-64 64a32 32 0 1 0 45 45l64-64a32 32 0 0 0 0-45zM192 352h640a64 64 0 0 1 64 64v384a96 96 0 0 1-96 96H224a96 96 0 0 1-96-96V416a64 64 0 0 1 64-64zm32 64v384a32 32 0 0 0 32 32h576a32 32 0 0 0 32-32V416H224zm160 128a32 32 0 1 0 0 64 32 32 0 0 0 0-64zm256 0a32 32 0 1 0 0 64 32 32 0 0 0 0-64z" fill="#00A1D6"/>
                  </svg>
                </div>
                <span class="platform-label">bilibili</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <router-link to="/voiceClone">
            <button class="btn-primary">开始视频下载</button>
          </router-link>
        </div>
      </div>
    </section>

    <!-- 常见问题 -->
    <section class="section-white">
      <div class="container">
        <div class="text-center">
          <h2 class="section-title">常见问题</h2>
        </div>
        <div class="faq-container">
          <div class="faq-list">
            <div v-for="(faq, index) in faqs" :key="index" class="faq-item">
              <button
                class="faq-question"
                :class="{ 'active': faq.isOpen }"
                @click="toggleFaq(index)"
              >
                <span>{{ faq.question }}</span>
                <i class="fas" :class="faq.isOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
              </button>
              <div v-if="faq.isOpen" class="faq-answer">
                <p>{{ faq.answer }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 - 优化版 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <!-- 公司信息区域 -->
          <div class="footer-section company-section">
            <h3 class="footer-title">关于我们</h3>
            <div class="company-info">
              <p><strong>深圳灵动帧智能科技有限公司</strong></p>
              <p>致力于提供高质量的媒体处理解决方案</p>
            </div>
          </div>
          <!-- 联系方式区域 -->
          <div class="footer-section contact-section">
            <h3 class="footer-title">联系我们</h3>
            <ul class="contact-list">
              <li><i class="fas fa-envelope"></i> <a href="mailto:wuyunxiong_cse@163.com">wuyunxiong_cse@163.com</a></li>
              <li><i class="fas fa-phone"></i> <a href="tel:+8600000000">19584690981</a></li>
              <li><i class="fas fa-map-marker-alt"></i> 深圳市南山区粤海街道高新区社区白石路3609深圳湾科技生态园2区9栋514-549</li>
            </ul>
          </div>
          <!-- 快速链接区域 -->
          <div class="footer-section links-section">
            <h3 class="footer-title">快速链接</h3>
            <ul class="quick-links">
              <li><a href="#video-translation">视频翻译</a></li>
              <li><a href="#audio-processing">音频处理</a></li>
            </ul>
          </div>
          <!-- 社交媒体和服务条款区域 -->
          <div class="footer-section legal-section">
            <h3 class="footer-title">关注我们</h3>
            <div class="social-icons">
              <a href="#" target="_blank"><i class="fab fa-weixin"></i></a>
              <a href="#" target="_blank"><i class="fab fa-weibo"></i></a>
              <a href="#" target="_blank"><i class="fab fa-qq"></i></a>
            </div>
            <div class="legal-links-container">
              <router-link to="/privacy-policy">
                <p>隐私政策</p>
              </router-link>
              <span class="divider">|</span>
              <router-link to="/user-agreement">
                <p>服务条款</p>
              </router-link>
            </div>
          </div>
        </div>
        <!-- 页脚底部区域 -->
        <div class="footer-bottom">
          <div class="footer-copyright">
            <p>© 2025 深圳灵动帧智能科技有限公司 版权所有</p>
            <div class="legal-links">
              <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">粤ICP备2025466713号</a>
              <span class="divider">|</span>
              <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">粤公网安备44030002007986号</a>
            </div>
          </div>
          <div class="payment-methods">
            <span>支付方式：</span>
            <i class="fab fa-alipay"></i>
            <i class="fab fa-weixin"></i>
          </div>
        </div>
      </div>
    </footer>

    <!-- 返回顶部按钮 -->
    <button v-show="showBackToTop" @click="scrollToTop" class="back-to-top">
      <i class="fas fa-arrow-up"></i>
    </button>
  </div>
</template>

<script>
import {
  TranSorURL,
  TranResURL,
  voiceDenoiseSorURL,
  voiceDenoiseResURL,
  voiceSrtSorURL,
  voiceSrtResURL,
  videoDownURL
} from '@/api/constants'

export default {
  name: 'mainPag',
  head () {
    return {
      link: [
        {
          rel: 'stylesheet',
          href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css'
        }
      ]
    }
  },
  data () {
    return {
      showBackToTop: false,
      TranSorURL,
      TranResURL,
      voiceDenoiseSorURL,
      voiceDenoiseResURL,
      voiceSrtSorURL,
      voiceSrtResURL,
      videoDownURL,
      faqs: [
        {
          question: '支持哪些视频格式？',
          answer: '我们支持几乎所有主流视频格式，包括 MP4、AVI、MOV、WMV、FLV、MKV 等。无论您的视频是什么格式，我们都能为您提供专业的处理服务。',
          isOpen: true
        },
        {
          question: '视频翻译的准确率如何？',
          answer: '我们的视频翻译采用先进的 AI 技术，结合专业语言专家的审核，翻译准确率可达 95% 以上。',
          isOpen: false
        },
        {
          question: '处理大文件需要多长时间？',
          answer: '处理时间取决于文件大小和所选功能。一般情况下，5 分钟的视频翻译约需 15-25 分钟。',
          isOpen: false
        },
        {
          question: '如何保证我上传文件的安全性？',
          answer: '所有数据传输均通过 HTTPS 加密。处理完成后，您可以选择立即删除服务器上的文件，或者系统会在 30 天后自动删除，确保您的数据安全。',
          isOpen: false
        }
      ]
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    // 动态加载Font Awesome
    if (!document.querySelector('link[href*="font-awesome"]')) {
      const link = document.createElement('link')
      link.rel = 'stylesheet'
      link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css'
      document.head.appendChild(link)
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      this.showBackToTop = window.scrollY > 500
    },
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    toggleFaq (index) {
      this.faqs = this.faqs.map((faq, i) => {
        if (i === index) {
          return { ...faq, isOpen: !faq.isOpen }
        }
        return { ...faq, isOpen: false }
      })
    }
  }
}
</script>

<style scoped>
/* 基础样式重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app {
  min-height: 100vh;
  background-color: #f9fafb;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  margin-top: 0vh;
}

/* 容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 区块样式 */
.section-white {
  padding: 36px 0;
  background-color: rgb(252, 252, 252);
}

.section-gray {
  padding: 36px 0;
  background-color: #ecf0f6ed;
}

/* 文本样式 */
.text-center {
  text-align: center;
  margin-top: 20px;
}

.section-title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #1a59b1;
  margin-bottom: 8px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.section-title:hover {
  color: #409efd;
}

.section-description {
  color: #2a2c2f;
  max-width: 768px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
}

/* 按钮样式 */
.btn-primary {
  background-color: #4f46e5;
  color: white;
  padding: 6px 6px;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.btn-primary:hover {
  background-color: #4338ca;
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.full-width {
  width: 100%;
}

/* 视频比较样式 */
.video-comparison {
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 2px;
}

@media (min-width: 768px) {
  .video-comparison {
    flex-direction: row;
  }
}

.video-player {
  flex: 1;
  background-color: #f3f4f6;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);

  /* 🌟 核心修复：创建独立的层叠上下文，防止内部 video 硬件加速层穿透遮挡外部 fixed 导航栏 */
  isolation: isolate;
  transform: translateZ(0);

  /* 🌟 核心修复：移动端默认 100% 宽度，防止固定宽度撑破屏幕 */
  width: 100%;
  max-width: 100%;
}

/* 桌面端保持原有尺寸限制 */
@media (min-width: 768px) {
  .video-comparison .video-player {
    width: 350px;
    min-width: 350px;
    max-width: 350px;
    flex: none;
    margin: 0 auto;
  }
}

.video-header {
  padding: 8px;
  background-color: #4f46e5;
  color: white;
}

.video-header h3 {
  font-weight: 400;
  margin: 0;
  text-align: center;
}

.video-content {
  position: relative;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;

  /* 🌟 核心修复：移动端使用 aspect-ratio 保持 16:9 比例自适应 */
  width: 100%;
  aspect-ratio: 16 / 9;
}

/* 桌面端恢复固定高度 */
@media (min-width: 768px) {
  .video-content {
    height: 350px;
    aspect-ratio: auto;
  }
}

.video-content video {
  width: 100%;
  height: 100%;
  max-width: 100%;
  object-fit: contain;
  display: block;
}

/* 桌面端恢复视频固定尺寸 */
@media (min-width: 768px) {
  .video-content video {
    width: auto;
    height: 350px;
    max-width: 350px;
  }
}

.video-controls {
  padding: 16px;
  background-color: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.controls-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.controls-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.control-btn {
  background: none;
  border: none;
  color: #374151;
  cursor: pointer;
  transition: color 0.3s ease;
}

.control-btn:hover {
  color: #4f46e5;
}

.progress-bar {
  width: 100px;
  height: 4px;
  background-color: #d1d5db;
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  width: 33.33%;
  height: 100%;
  background-color: #4f46e5;
}

.time-display {
  font-size: 12px;
  color: #6b7280;
}

/* 功能网格样式 */
.features-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-top: 24px;
}

@media (min-width: 768px) {
  .features-grid {
    grid-template-columns: repeat(3, 1fr);
    justify-items: center;
  }
}

@media (min-width: 1024px) {
  .features-grid {
    grid-template-columns: repeat(3, 1fr);
    justify-items: center;
  }
}

.feature-card {
  background-color: rgb(233, 233, 233);
  padding: 6px;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
  width: 100%;
  max-width: 260px;
  margin: 0 auto;
}

.feature-card:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  color: #4f46e5;
  margin-bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.feature-icon i {
  font-size: 1.5rem;
}

.feature-card h3,
.feature-card p {
  text-align: center;
}

.feature-card h3 {
  font-size: 1rem;
  font-weight: 550;
  margin-bottom: 8px;
}

.feature-card p {
  color: #585f6e;
}

/* 音频处理样式 */
.audio-processing-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  margin-bottom: 24px;
}

@media (min-width: 768px) {
  .audio-processing-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.audio-processing-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.audio-content {
  padding: 12px;
}

.audio-section {
  margin-bottom: 6px;
}

.audio-section h4 {
  color: #374151;
  font-weight: 500;
  margin-bottom: 8px;
}

.audio-player {
  background-color: #f3f4f6;
  padding: 6px;
  border-radius: 8px;
}

.audio-player audio {
  width: 100%;
  height: 30px;
}

.subtitle-section h4 {
  color: #374151;
  font-weight: 500;
  margin-bottom: 8px;
}

.subtitle-content {
  background-color: #f3f4f6;
  padding: 16px;
  border-radius: 8px;
  height: 130px;
  overflow-y: auto;
}

.subtitle-item {
  margin-bottom: 8px;
}

.subtitle-time {
  font-size: 12px;
  color: #6b7280;
}

.subtitle-item p {
  color: #1f2937;
  margin: 0;
}

/* 下载样式 */
.download-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  padding: 24px;
}

.download-interface {
  max-width: 480px;
  margin: 0 auto 24px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}

.download-interface img {
  width: auto;
  height: 400px;
  max-width: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  display: block;
}

.supported-platforms {
  background-color: #f9fafb;
  padding: 12px;
  border-radius: 8px;
}

.supported-platforms h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 8px;
  text-align: center;
}

.platform-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

@media (min-width: 640px) {
  .platform-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 768px) {
  .platform-grid {
    grid-template-columns: repeat(6, 1fr);
  }
}

.platform-item {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.platform-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
}

.platform-icon-wrapper i {
  font-size: 2rem;
}

.platform-icon-wrapper i.fa-youtube {
  color: #ef4444;
}

.platform-icon-wrapper svg {
  width: 2rem;
  height: 2rem;
}

.platform-label {
  font-size: 1rem;
  color: #374151;
  text-align: center;
  font-weight: 500;
}

/* FAQ样式 */
.faq-container {
  max-width: 768px;
  margin: 0 auto;
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.faq-item {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px;
  text-align: left;
  font-weight: 500;
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.3s ease;
  color: #374151;
}

.faq-question.active {
  color: #4f46e5;
}

.faq-question:focus {
  outline: none;
}

.faq-answer {
  padding: 0 16px 16px;
}

.faq-answer p {
  color: #6b7280;
  margin: 0;
}

/* 页脚样式 - 优化版 */
.footer {
  background-color: #1f2937;
  color: white;
  padding: 48px 0 32px;
}

.footer-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  margin-bottom: 32px;
}

@media (min-width: 768px) {
  .footer-content {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
}

@media (min-width: 1024px) {
  .footer-content {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }
}

/* 页脚标题统一样式 */
.footer-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 16px;
  color: #f3f4f6;
  position: relative;
  padding-bottom: 10px;
}

.footer-title:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 2px;
  background-color: #4f46e5;
}

/* 公司信息区域样式 */
.company-section {
  margin-bottom: 16px;
}

.company-info {
  margin-top: 8px;
}

.company-info p {
  margin-bottom: 8px;
  color: #9ca3af;
  font-size: 0.95rem;
  line-height: 1.5;
}

.company-info strong {
  color: #f3f4f6;
  display: inline-block;
  margin-bottom: 4px;
}

/* 联系方式区域样式 */
.contact-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.contact-list li {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.contact-list li i {
  color: #60a5fa;
  margin-right: 12px;
  width: 16px;
  text-align: center;
}

.contact-list a {
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.3s ease;
}

.contact-list a:hover {
  color: #f3f4f6;
}

/* 快速链接区域样式 */
.quick-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.quick-links li {
  margin-bottom: 12px;
}

.quick-links a {
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.3s ease;
  position: relative;
  padding-left: 16px;
  display: inline-block;
}

.quick-links a:before {
  content: '›';
  position: absolute;
  left: 0;
  color: #60a5fa;
}

.quick-links a:hover {
  color: #f3f4f6;
}

/* 社交媒体和法律链接区域样式 */
.social-icons {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.social-icons a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: #374151;
  border-radius: 50%;
  color: #f3f4f6;
  transition: all 0.3s ease;
}

.social-icons a:hover {
  background-color: #4f46e5;
  transform: translateY(-2px);
}

.legal-links-container {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}

.legal-links-container p {
  margin: 0;
}

.legal-links-container a {
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: 0.9rem;
}

.legal-links-container a:hover {
  color: #f3f4f6;
}

.legal-links-container .divider {
  color: #4b5563;
  margin: 0 8px;
}

/* 页脚底部区域 */
.footer-bottom {
  border-top: 1px solid #374151;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

@media (min-width: 768px) {
  .footer-bottom {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }
}

.footer-copyright {
  text-align: center;
}

@media (min-width: 768px) {
  .footer-copyright {
    text-align: left;
  }
}

.footer-copyright p {
  color: #9ca3af;
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.legal-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

@media (min-width: 768px) {
  .legal-links {
    justify-content: flex-start;
  }
}

.legal-links a {
  color: #9ca3af;
  text-decoration: none;
  font-size: 0.85rem;
}

.legal-links a:hover {
  color: #f3f4f6;
}

.legal-links .divider {
  color: #4b5563;
}

.payment-methods {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
  margin-right: 125px;
}

@media (min-width: 768px) {
  .payment-methods {
    margin-top: 0;
  }
}

.payment-methods span {
  color: #9ca3af;
  font-size: 0.9rem;
}

.payment-methods i {
  font-size: 1.5rem;
  transition: transform 0.3s ease;
}

.payment-methods i:hover {
  transform: scale(1.1);
}

.payment-methods i.fa-alipay {
  color: #00a0e9;
}

.payment-methods i.fa-weixin {
  color: #07c160;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  right: 24px;
  bottom: 24px;
  background-color: #4f46e5;
  color: white;
  padding: 12px;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1000;
}

.back-to-top:hover {
  background-color: #4338ca;
}

/* 自定义滚动条 */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* 移除 number 输入框的箭头 */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

/* 设置主要按钮与上级元素的间距为8px */
.text-center > .btn-primary {
  margin-top: 16px;
}

.platform-center {
  justify-content: center !important;
  display: flex !important;
  gap: 32px;
}
</style>
